import type { AnalysisRow, AnalysisStepRow } from "@/types/supabase.types";

export type MatrixColumnType = "text" | "badge" | "list";
export type MatrixValueSource = "manual" | "generated";

export type MatrixColumnDef = {
  key: string;
  label: string;
  type: MatrixColumnType;
  width: number;
  order: number;
  displayDescription?: string;
};

export type MatrixCellUi = {
  value: string;
  status?: AnalysisStepRow["analysis_step_status"];
  source?: MatrixValueSource;
};

export class MatrixCompatibilityError extends Error {
  readonly collectionId: string;
  readonly incompatibleAnalysisIds: string[];

  constructor(collectionId: string, incompatibleAnalysisIds: string[]) {
    super("This matrix contains rows with incompatible structures.");
    this.name = "MatrixCompatibilityError";
    this.collectionId = collectionId;
    this.incompatibleAnalysisIds = incompatibleAnalysisIds;
  }
}

export type MatrixRowUi = {
  analysisId: string;
  displayName: string;
  status: AnalysisRow["analysis_status"];
  createdAt: string;
  cells: Record<string, MatrixCellUi>;
};

export type MatrixUi = {
  collectionId: string;
  name: string;
  question: string;
  columns: MatrixColumnDef[];
  rows: MatrixRowUi[];
};

export type MatrixListItemUi = {
  collectionId: string;
  name: string;
  rowCount: number;
  updatedAt: string;
  columns: MatrixColumnDef[];
  // The first rows, in creation order.
  previewRows: MatrixPreviewRowUi[];
};

export type MatrixPreviewRowUi = {
  analysisId: string;
  // The first column's value, empty while blank or not yet run.
  value: string;
};
